import React from 'react';
import BaseForm from './VotingForm/BaseForm';
import { CandidatesProvider } from './CandidatesContext';

const Content: React.FC = () => {
  return (
    <>
      <CandidatesProvider>
        <BaseForm/>
      </CandidatesProvider>
    </>
  );
};

export default Content;